"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveResults = exports.retrieveResultsSummary = void 0;

var surveys = _interopRequireWildcard(require("./index"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var who5 = {
  low: "Your wellbeing is less than the average. You might be going through a tough stretch so please remember to reach out and get some good support to help you through it.",
  average: "Good to hear that your wellbeing is around same level as most adults nationally. Wellbeing is subjective and has ups and downs of course but your average is similar to others.",
  high: "Great to hear you are doing well compared to the overall population. How you feel is a personal thing but we hope that you’re feeling as great as your score."
};
var who5Postprogram = {
  veryLow: "Your wellbeing score indicates you are surviving, compared to the global population. ",
  low: "Your wellbeing score indicates you are surviving, compared to the global population. ",
  average: "Your wellbeing score indicates you are thriving, compared to the global population. ",
  high: "Your wellbeing score indicates you are thriving, compared to the global population. ",
  veryHigh: "Your wellbeing score indicates you are thriving, compared to the global population. "
};
var stress = {
  low: "You’re doing a great job managing your stress. You still might feel stressed from time to time as this score is only about your stress levels compared with other people.",
  average: "Good to hear that your stress levels are similar to other people. Stress can go up and down but congrats on the work you’ve done to keep it from going too high.",
  high: "Sorry to hear that your stress levels are high at the moment. You might be resilient but remember you don’t have to do it alone. Please reach out for help as well."
};
var stressPostprogram = {
  veryLow: "Your stress score indicates you are thriving, compared to the global population. ",
  low: "Your stress score indicates you are thriving, compared to the global population. ",
  average: "Your stress score indicates you are thriving, compared to the global population. ",
  high: "Your stress score indicates you are surviving, compared to the global population. ",
  veryHigh: "Your stress score indicates you are surviving, compared to the global population. "
};

var who5Summary = function who5Summary(who5Score) {
  var text = who5.veryLow;
  var summary = "Very Low"; // TODO: move these ifs into WHO5 battery.

  if (who5Score <= 35) {
    text = who5.low;
    summary = "Low";
  } else if (who5Score > 35 && who5Score < 75) {
    text = who5.average;
    summary = "Average";
  } else if (who5Score >= 75) {
    text = who5.high;
    summary = "High";
  }

  return {
    title: "Wellbeing",
    summary: summary,
    text: text,
    score: who5Score
  };
};

var stressSummary = function stressSummary(stressScore) {
  // TODO: move these ifs into PSS battery.
  var text = stress.low;
  var summary = "Much Lower than Average";

  if (stressScore <= 28) {
    text = stress.low;
    summary = "Slightly Lower than Average";
  } else if (stressScore <= 50) {
    text = stress.average;
    summary = "Average";
  } else if (stressScore > 50) {
    text = stress.high;
    summary = "Slightly Higher than Average";
  }

  return {
    title: "Stress",
    summary: summary,
    text: text,
    score: stressScore
  };
};

var who5SummaryPost = function who5SummaryPost(who5ScorePost, who5ScorePre) {
  // TODO: move these ifs into WHO5 battery.
  var veryLowTypeA = "We’re happy to see that your score has improved, but sorry to hear that it still appears to be a tough time for you. Your score also indicates that you might be feeling depressed. We suggest that you speak to your coach, workplace counselling service, or GP about support options available. Continued practice of the Uprise skills should also help.";
  var veryLowTypeB = "It appears to have been a tough time for you, and in spite of your efforts we’re sorry to see that your score hasn’t improved. Your score also indicates that you might feel depressed. We suggest that you speak to your coach, workplace counselling service or GP about support options available. Continued practice of the Uprise skills should also help.";
  var text = who5Postprogram.veryLow + (who5ScorePost > who5ScorePre ? veryLowTypeA : veryLowTypeB);
  var summary = "(0-27) Very low";

  if (who5ScorePost > 35) {
    var LowTypeA = "We’re happy to see that your score has improved, but sorry to hear that it still appears to be a tough time for you. Your score also indicates that you might be at-risk of experiencing a depressed mood. We suggest that you speak to your coach, workplace counselling service or GP about support options available. Continued practice of the Uprise skills should also help.";
    var LowTypeB = "It appears to be a tough time for you and in spite of your efforts we’re sorry to see that your score hasn’t improved. Your score also indicates that you might be at-risk of experiencing a depressed mood. We suggest that you speak to your coach, workplace counselling service or GP about support options available. Continued practice of the Uprise skills should also help.";
    text = who5Postprogram.low + (who5ScorePost > who5ScorePre ? LowTypeA : LowTypeB);
    summary = "(28-49) Low";
  }

  if (who5ScorePost > 50) {
    var AverageTypeA = "We’re happy to see that your score has improved. We suggest that you continue using the skills from the program to achieve greater levels of wellbeing.";
    var AverageTypeB = "We’re glad to see that you’re feeling okay, but it seems like your score hasn’t improved in spite of your efforts. We encourage you continue using the skills from the program to gain improvements, that are often only realised over time.";
    text = who5Postprogram.average + (who5ScorePost > who5ScorePre ? AverageTypeA : AverageTypeB);
    summary = "(50-70) Average";
  }

  if (who5ScorePost > 71) {
    var HighTypeA = "We’re happy to see that your score has improved, and that you have been feeling well. We suggest that you continue using the skills from the program to reach peak wellbeing.";
    var HighTypeB = "We’re glad to see that you have been feeling well. We encourage you to continue using the skills from the program to make further gains, that are often only realised over time.";
    text = who5Postprogram.high + (who5ScorePost > who5ScorePre ? HighTypeA : HighTypeB);
    summary = "(71-85) High";
  }

  if (who5ScorePost > 86) {
    var VeryHighTypeA = "We’re happy to see that you have been feeling very well, and that your score has improved. You’re in the highest range for wellbeing. We suggest that you continue using the skills from the program to maintain peak wellbeing.";
    var VeryHighTypeB = "We’re glad to see that you’re feeling very well, and that you’re in the highest range for wellbeing. We suggest that you continue to use the skills from the program to make further gains, that are often only realised over time.";
    text = who5Postprogram.veryHigh + (who5ScorePost > who5ScorePre ? VeryHighTypeA : VeryHighTypeB);
    summary = "(86-100) Very High";
  }

  return {
    summary: summary,
    text: text,
    score: who5ScorePost
  };
};

var stressSummaryPost = function stressSummaryPost(stressScorePost, stressScorePre) {
  // TODO: move these ifs into PSS battery.
  var veryLowTypeA = "We’re happy to see that your score has improved and that managing stress doesn’t appear to be a problem for you right now. We suggest that you continue using the skills from the program to gain further improvements.";
  var veryLowTypeB = "We’re glad to see that you still seem to be managing stress well. We suggest that you continue using the skills from the program to gain improvements, that are often only realised over time.";
  var text = stressPostprogram.veryLow + (postPssScore < prePssScore ? veryLowTypeA : veryLowTypeB);
  var summary = "(0-16) Very Low";

  if (postPssScore > 17) {
    var LowTypeA = "We’re happy to see that your score has improved and that managing stress doesn’t appear to be a problem for you right now. We suggest that you continue using the skills from the program to gain further improvements.";
    var LowTypeB = "We’re glad to see that you still seem to be managing stress well. We suggest that you continue using the skills from the program to gain improvements, that are often only realised over time.";
    text = stressPostprogram.low + (postPssScore < prePssScore ? LowTypeA : LowTypeB);
    summary = "(17-35) Low";
  }

  if (postPssScore > 36) {
    var AverageTypeA = "We’re happy to see that your score has improved. We suggest that you continue using the skills from the program to gain further improvements.";
    var AverageTypeB = "We’re glad to see that you still seem to be managing stress adequately, but in spite of your efforts your score has not improved. We suggest that you continue using the skills from the program to gain improvements, that are often only realised over time.";
    text = stressPostprogram.average + (postPssScore < prePssScore ? AverageTypeA : AverageTypeB);
    summary = "(36-54) Average";
  }

  if (postPssScore > 55) {
    var HighTypeA = "We’re happy to see that your score has improved, however stress is still probably affecting your ability to live and work effectively. We suggest that you continue using the skills from the program to gain further improvements. You can also speak to your coach, workplace counselling service or GP about other support options available.";
    var HighTypeB = "We’re sorry to see that in spite of your efforts your score hasn’t improved, and that stress is still probably affecting your ability to live and work effectively. We suggest that you continue using the skills from the program to gain further improvements. You can also speak to your coach, workplace counselling service or GP about other support options available.";
    text = stressPostprogram.high + (postPssScore < prePssScore ? HighTypeA : HighTypeB);
    summary = "(55-79) High";
  }

  if (postPssScore > 80) {
    var VeryHighTypeA = "We’re happy to see that your score has improved, however, it seems that stress still has a great impact on your ability to live and work effectively. We suggest that you continue using the skills from the program to gain further improvements. You can also speak to your coach, workplace counselling service or GP about other support options available.";
    var VeryHighTypeB = "We’re sorry to see that your score hasn’t improved in spite of your efforts. It seems that stress is still having a large impact on your ability to live and work effectively. We suggest that you continue using the skills from the program to gain further improvements. You can also speak to your coach, workplace counselling service or GP about other support options available.";
    text = stressPostprogram.veryHigh + (postPssScore < prePssScore ? VeryHighTypeA : VeryHighTypeB);
    summary = "(80-100) Very High";
  }

  return {
    summary: summary,
    text: text,
    score: postPssScore
  };
};

var retrieveOnboardingStudentResults = function retrieveOnboardingStudentResults(survey) {
  var stressSum;
  var who5Sum;

  if (survey.taskId === "survey-onboarding") {
    // Pre program survey result
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var WHO5 = results.WHO5.WHO5;
    var STRESS_SCORE = results.STRESS_STUDENTS.STRESS_SCORE;
    stressSum = stressSummary(STRESS_SCORE);
    who5Sum = who5Summary(WHO5);
  }

  return {
    stress: _objectSpread(_objectSpread({}, stressSum), {
      timestamp: survey.timestamp,
      dialogueId: "stressCheck"
    }),
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveOnboardingResults = function retrieveOnboardingResults(survey) {
  var stressSum;
  var who5Sum;

  if ("survey-onboarding" === survey.taskId) {
    // Pre program survey result
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var WHO5 = results.WHO5.WHO5;
    var STRESS_SCORE = results.STRESS.STRESS_SCORE;
    stressSum = stressSummary(STRESS_SCORE);
    who5Sum = who5Summary(WHO5);
  }

  return {
    stress: _objectSpread(_objectSpread({}, stressSum), {
      timestamp: survey.timestamp,
      dialogueId: "stressCheck"
    }),
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveAllianzOnboardingResults = function retrieveAllianzOnboardingResults(survey) {
  var stressSum;
  var who5Sum;

  if ("survey-onboarding" === survey.taskId) {
    // Pre program survey result
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var WHO5 = results.WHO5.WHO5;
    var STRESS_SCORE = results.ALLIANZ_STRESS.STRESS_SCORE;
    stressSum = stressSummary(STRESS_SCORE);
    who5Sum = who5Summary(WHO5);
  }

  return {
    stress: _objectSpread(_objectSpread({}, stressSum), {
      timestamp: survey.timestamp,
      dialogueId: "stressCheck"
    }),
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveMedibankOnboardingResults = function retrieveMedibankOnboardingResults(survey) {
  var stressSum;
  var who5Sum;

  if ("survey-onboarding" === survey.taskId) {
    // Pre program survey result
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var WHO5 = results.WHO5.WHO5;
    var STRESS_SCORE = results.MEDIBANK_STRESS_ONBOARDING.STRESS_SCORE;
    stressSum = stressSummary(STRESS_SCORE);
    who5Sum = who5Summary(WHO5);
  }

  return {
    stress: _objectSpread(_objectSpread({}, stressSum), {
      timestamp: survey.timestamp,
      dialogueId: "stressCheck"
    }),
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveOnboardingRtwUSResults = function retrieveOnboardingRtwUSResults(survey) {
  var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
  var WHO5 = results.WHO5RTWUS.WHO5;
  var who5Sum = who5Summary(WHO5);
  return {
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveWellbeingResults = function retrieveWellbeingResults(survey) {
  var who5Sum;

  if (survey.taskId === "survey-wellbeing-check" || survey.taskId === "survey-progress" || survey.taskId === "survey-stress-wellbeing-monthly" || survey.taskId === "survey-stress-wellbeing-weekly") {
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var WHO5 = results.WHO5.WHO5;
    who5Sum = who5Summary(WHO5);
  }

  return {
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveProgressResults = function retrieveProgressResults(survey) {
  var stressSum;
  var who5Sum;

  if (survey.taskId === "survey-progress" || survey.taskId === "survey-stress-wellbeing-monthly" || survey.taskId === "survey-stress-wellbeing-weekly") {
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var WHO5 = results.WHO5.WHO5;
    var STRESS_SCORE = results.STRESS.STRESS_SCORE;
    stressSum = stressSummary(STRESS_SCORE);
    who5Sum = who5Summary(WHO5);
  }

  return {
    stress: _objectSpread(_objectSpread({}, stressSum), {
      timestamp: survey.timestamp,
      dialogueId: "stressCheck"
    }),
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveAllianzProgressResults = function retrieveAllianzProgressResults(survey) {
  var stressSum;
  var who5Sum;

  if (survey.taskId === "survey-progress" || survey.taskId === "survey-stress-wellbeing-monthly" || survey.taskId === "survey-stress-wellbeing-weekly") {
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var WHO5 = results.WHO5.WHO5;
    var STRESS_SCORE = results.ALLIANZ_STRESS.STRESS_SCORE;
    stressSum = stressSummary(STRESS_SCORE);
    who5Sum = who5Summary(WHO5);
  }

  return {
    stress: _objectSpread(_objectSpread({}, stressSum), {
      timestamp: survey.timestamp,
      dialogueId: "stressCheck"
    }),
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveMedibankProgressResults = function retrieveMedibankProgressResults(survey) {
  var stressSum;
  var who5Sum;

  if (survey.taskId === "survey-progress" || survey.taskId === "survey-stress-wellbeing-monthly" || survey.taskId === "survey-stress-wellbeing-weekly") {
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var WHO5 = results.WHO5.WHO5;
    var STRESS_SCORE = results.STRESS.STRESS_SCORE;
    stressSum = stressSummary(STRESS_SCORE);
    who5Sum = who5Summary(WHO5);
  }

  return {
    stress: _objectSpread(_objectSpread({}, stressSum), {
      timestamp: survey.timestamp,
      dialogueId: "stressCheck"
    }),
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveMedibankProgressResultsV1 = function retrieveMedibankProgressResultsV1(survey) {
  var stressSum;
  var who5Sum;

  if (survey.taskId === "survey-progress" || survey.taskId === "survey-stress-wellbeing-monthly" || survey.taskId === "survey-stress-wellbeing-weekly") {
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var WHO5 = results.WHO5.WHO5;
    var STRESS_SCORE = results.MEDIBANK_STRESS_V1.STRESS_SCORE;
    stressSum = stressSummary(STRESS_SCORE);
    who5Sum = who5Summary(WHO5);
  }

  return {
    stress: _objectSpread(_objectSpread({}, stressSum), {
      timestamp: survey.timestamp,
      dialogueId: "stressCheck"
    }),
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveMedibankProgressResultsV1x1 = function retrieveMedibankProgressResultsV1x1(survey) {
  var stressSum;
  var who5Sum;

  if (survey.taskId === "survey-progress" || survey.taskId === "survey-stress-wellbeing-monthly" || survey.taskId === "survey-stress-wellbeing-weekly") {
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var WHO5 = results.WHO5.WHO5;
    var STRESS_SCORE = results.MEDIBANK_STRESS_V2.STRESS_SCORE;
    stressSum = stressSummary(STRESS_SCORE);
    who5Sum = who5Summary(WHO5);
  }

  return {
    stress: _objectSpread(_objectSpread({}, stressSum), {
      timestamp: survey.timestamp,
      dialogueId: "stressCheck"
    }),
    who5: _objectSpread(_objectSpread({}, who5Sum), {
      timestamp: survey.timestamp,
      dialogueId: "wellbeingCheck"
    })
  };
};

var retrieveStressResults = function retrieveStressResults(survey) {
  var stressSum;

  if (survey.taskId === "survey-stress-wellbeing-monthly" || survey.taskId === "survey-stress-wellbeing-weekly" || survey.taskId === "survey-stress-check") {
    // Pre program survey result
    var results = surveys.retrieveSurvey(survey.surveyId).analysis(survey.answers);
    var STRESS_SCORE = results.STRESS.STRESS_SCORE;
    stressSum = stressSummary(STRESS_SCORE);
  }

  return {
    stress: _objectSpread(_objectSpread({}, stressSum), {
      timestamp: survey.timestamp,
      dialogueId: "stressCheck"
    })
  };
};

var retrieveResultsSummary = function retrieveResultsSummary(survey1, survey2, who5Onboarding) {
  var stress = null;
  var who5 = null; // Need to compare before rendering

  if (survey2 && survey1 && survey2.taskId === "survey-preprogram" && survey1.taskId === "survey-postprogram") {
    // Post program survey result
    var postResult = surveys.retrieveSurvey(survey1.surveyId).analysis(survey1.answers); // Pre program survey result

    var stressPre = surveys.retrieveSurvey(survey2.surveyId).analysis(survey2.answers);
    var onboardingResultWho5 = surveys.retrieveSurvey(who5Onboarding.surveyId).analysis(who5Onboarding.answers);
    stress = stressSummaryPost(postResult.PSS, stressPre.PSS);
    who5 = who5SummaryPost(postResult.WHO5, onboardingResultWho5.WHO5);
  } // Calculate monthly survey results


  if (survey2 && survey1 && survey2.taskId === "survey-preprogram" && survey1.taskId === "survey-stress-wellbeing-monthly") {
    // Post program survey result
    var monthlyResult = surveys.retrieveSurvey(survey1.surveyId).analysis(survey1.answers); // Pre program survey result

    var _stressPre = surveys.retrieveSurvey(survey2.surveyId).analysis(survey2.answers);

    var who5pre = surveys.retrieveSurvey(who5Onboarding.surveyId).analysis(who5Onboarding.answers);
    stress = stressSummaryPost(monthlyResult.PSS, _stressPre.STRESS_SCORE);
    who5 = who5SummaryPost(monthlyResult.WHO5, who5pre.WHO5);
  }
};

exports.retrieveResultsSummary = retrieveResultsSummary;

var retrieveResults = function retrieveResults(survey) {
  switch (survey.surveyId) {
    case "onboarding-v1.1":
    case "onboarding-v1":
    case "onboarding-medibank-v1":
      return retrieveOnboardingResults(survey);

    case "onboarding-students-v1":
      return retrieveOnboardingStudentResults(survey);

    case "wellbeing-check-v1":
      return retrieveWellbeingResults(survey);

    case "progress-v1":
    case "wellbeingStressMonthly-v1":
    case "wellbeingStressWeekly-v1":
    case "wellbeingStressMonthly-v1.1":
    case "wellbeingStressWeekly-v1.1":
      return retrieveProgressResults(survey);

    case "stress-check-v1":
      return retrieveStressResults(survey);

    case "onboarding-rtw-us-v1.0":
      return retrieveOnboardingRtwUSResults(survey);

    case "onboarding-rtw-us-v1.1":
      return retrieveOnboardingRtwUSResults(survey);

    case "progress-rtw-us-v1.0":
      return retrieveOnboardingRtwUSResults(survey);

    case "allianz-progress-v1":
    case "wellbeingStressMonthly-allianz-v1":
    case "wellbeingStressWeekly-allianz-v1":
      return retrieveAllianzProgressResults(survey);

    case "onboarding-allianz-v1":
      return retrieveAllianzOnboardingResults(survey);

    case "wellbeingStressMonthly-medibank-v1":
    case "wellbeingStressWeekly-medibank-v1":
      return retrieveMedibankProgressResults(survey);

    case "medibank-progress-v1":
    case "wellbeingStressMonthly-medibank-v1.1":
    case "wellbeingStressWeekly-medibank-v1.1":
      return retrieveMedibankProgressResultsV1(survey);

    case "medibank-progress-v1.1":
    case "medibank-progress-v1.2":
    case "wellbeingStressMonthly-medibank-v1.2":
    case "wellbeingStressWeekly-medibank-v1.2":
      return retrieveMedibankProgressResultsV1x1(survey);

    case "onboarding-medibank-v1.1":
      return retrieveMedibankOnboardingResults(survey);
  }
};

exports.retrieveResults = retrieveResults;